import { normalizeTutorialLanguage } from "../tutorials/language";

export function buildTournamentControllerUrl(inviteToken, configuredServer, pageOrigin = window.location.origin, language = null) {
  if (!inviteToken) return null;
  const server = String(configuredServer || pageOrigin).replace(/\/+$/, '');
  const url = new URL(`${server}/tournament/controller/index.html`);
  url.searchParams.set("invite", inviteToken);
  if (language) url.searchParams.set("lang", normalizeTutorialLanguage(language));
  return url.toString();
}
